import React, { useState, useEffect, Fragment } from 'react';
import DateRangePicker from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css';
import Moment from 'moment';
import Popover from 'react-tiny-popover';
import MensajeAvior from './MensajeAdvertencia';
import LoaderScreen from '../layout/LoaderScreen';
import 'moment/locale/es';

const Paso1 = (props) => {
    Moment.locale('es');
    const [ActivarLoader, setActivarLoader] = useState(false);

    // Estados principales del formulario
    const [tieneDocumentos, setTieneDocumentos] = useState(null);
    const [tipoIngreso, setTipoIngreso] = useState('localizador'); // 'ticket' o 'localizador'

    // Campos para tipoIngreso === 'ticket'
    const [numeroTicketUnico, setNumeroTicketUnico] = useState("");
    const [errorTicketUnico, setErrorTicketUnico] = useState("");

    // Campos para tipoIngreso === 'localizador'
    const [localizador, setLocalizador] = useState("");
    const [errorLocalizador, setErrorLocalizador] = useState("");
    const [especificarTicketsLocalizador, setEspecificarTicketsLocalizador] = useState(false); // Checkbox
    const [ticketsDelLocalizador, setTicketsDelLocalizador] = useState(['']); // Múltiples tickets
    const [erroresTicketsLocalizador, setErroresTicketsLocalizador] = useState([]);

    // Campo común
    const [fechaCompra, setFechaCompra] = useState(Moment(new Date()));
    const [ActivarPopoverFechas, setActivarPopoverFechas] = useState(false);
    // Podrías añadir un estado de error para la fecha si es necesario: const [errorFecha, setErrorFecha] = useState("");


    const LONGITUD_LOCALIZADOR = 6;
    const LONGITUD_TICKET = 13;
    const PREFIJO_TICKET = "742";

    // -------------------------------------------------------------------------------------------------
    // FUNCIONES DE VALIDACIÓN
    // -------------------------------------------------------------------------------------------------
    const esAlfanumerico = (inputtxt) => /^[A-Za-z0-9]+$/.test(inputtxt);
    const solonumeros = (inputtxt) => /^[0-9]+$/.test(inputtxt);

    const validarFormatoLocalizador = (loc) => {
        if (!loc || loc.trim() === "") return "El localizador es requerido.";
        if (!esAlfanumerico(loc)) return "Debe contener solo letras y números.";
        if (loc.length !== LONGITUD_LOCALIZADOR) return `Debe tener ${LONGITUD_LOCALIZADOR} caracteres.`;
        return "";
    };

    const validarFormatoTicket = (ticket) => {
        if (!ticket || ticket.trim() === "") return "El número de ticket es requerido.";
        if (!solonumeros(ticket)) return "El ticket debe contener solo números.";
        if (ticket.length !== LONGITUD_TICKET) return `El ticket debe tener ${LONGITUD_TICKET} dígitos.`;
        if (!ticket.startsWith(PREFIJO_TICKET)) return `El ticket debe iniciar con ${PREFIJO_TICKET}.`;
        return "";
    };

    // -------------------------------------------------------------------------------------------------
    // CONSTRUCCIÓN Y PARSEO DE LOCALSTORAGE (CLAVE "Boleto")
    // -------------------------------------------------------------------------------------------------

    const construirYGuardarValorBoletoStorage = () => {
        if (!tieneDocumentos) {
            window.localStorage.removeItem("Boleto");
            return;
        }

        let parts = [];
        // parts.push(`Fecha:${fechaCompra ? fechaCompra.toISOString() : 'N/A'}`);
        parts.push(`Tipo:${tipoIngreso}`);

        if (tipoIngreso === 'ticket') {
            parts.push(`TicketNro:${numeroTicketUnico || 'N/A'}`);
        } else if (tipoIngreso === 'localizador') {
            parts.push(`Loc:${localizador || 'N/A'}`);
            parts.push(`EspecificarTickets:${especificarTicketsLocalizador}`);
            if (especificarTicketsLocalizador) {
                const ticketsValidos = ticketsDelLocalizador.filter(t => t && t.trim() !== "");
                if (ticketsValidos.length > 0) {
                    parts.push(`Tickets:[${ticketsValidos.join(',')}]`);
                } else {
                    parts.push(`Tickets:[]`); // Indica que se especificó pero no se ingresaron tickets
                }
            }
        }
        window.localStorage.setItem("Boleto", parts.join('; '));
    };

    const parsearYEstablecerValorBoletoStorage = (cadenaBoleto) => {
        if (!cadenaBoleto) return;

        const data = {};
        cadenaBoleto.split('; ').forEach(part => {
            const [key, ...valueParts] = part.split(':');
            const value = valueParts.join(':'); // Reconstruir valor si contenía ':'
            data[key] = value;
        });

        if (data.Fecha && data.Fecha !== 'N/A') setFechaCompra(Moment(data.Fecha));

        const tipo = data.Tipo || 'localizador'; // Default a localizador si no se encuentra
        setTipoIngreso(tipo);

        if (tipo === 'ticket') {
            setNumeroTicketUnico(data.TicketNro !== 'N/A' ? data.TicketNro : "");
        } else if (tipo === 'localizador') {
            setLocalizador(data.Loc !== 'N/A' ? data.Loc : "");
            const especificar = data.EspecificarTickets === 'true';
            setEspecificarTicketsLocalizador(especificar);
            if (especificar && data.Tickets && data.Tickets !== '[]') {
                const ticketsStr = data.Tickets.substring(1, data.Tickets.length - 1); // Remover '[' y ']'
                if (ticketsStr) {
                    setTicketsDelLocalizador(ticketsStr.split(','));
                } else {
                    setTicketsDelLocalizador(['']);
                }
            } else if (especificar) { // Especificar es true pero no hay tickets o es '[]'
                setTicketsDelLocalizador(['']);
            }
        }
    };


    // -------------------------------------------------------------------------------------------------
    // MANEJADORES DE EVENTOS Y CAMBIOS DE ESTADO
    // -------------------------------------------------------------------------------------------------

    const resetearCamposSegunTipo = (nuevoTipo) => {
        setNumeroTicketUnico("");
        setErrorTicketUnico("");
        setLocalizador("");
        setErrorLocalizador("");
        setEspecificarTicketsLocalizador(false);
        setTicketsDelLocalizador(['']);
        setErroresTicketsLocalizador([]);
    };

    const handleTieneDocumentosChange = (valorString) => {
        if (valorString === "null") {
            setTieneDocumentos(null);
            window.localStorage.removeItem("TieneDocumentos");
            return;
        }
        const posee = valorString === "true";
        setTieneDocumentos(posee);
        window.localStorage.setItem("TieneDocumentos", posee.toString());
        if (!posee) {
            resetearCamposSegunTipo(tipoIngreso); // Limpia todos los campos
            setFechaCompra(Moment(new Date())); // Resetea fecha
            window.localStorage.removeItem("Boleto");
            window.localStorage.setItem("Paso1", btoa(true));
        } else {
            // Si dice que sí tiene, y había algo en localStorage "Boleto", se carga en useEffect
            // Si no, los campos estarán vacíos para ser llenados
            CamposObligatoriosCorrectos(); // Revalida el paso
        }
    };

    const handleTipoIngresoChange = (event) => {
        const nuevoTipo = event.target.value;
        resetearCamposSegunTipo(nuevoTipo); // Limpia campos del tipo anterior y actual
        setTipoIngreso(nuevoTipo);
        // No construimos el valor de storage aquí directamente, se hará al cambiar los campos específicos
        CamposObligatoriosCorrectos();
    };

    const handleFechaChange = (value) => {
        setFechaCompra(value);
        setActivarPopoverFechas(false);
        CamposObligatoriosCorrectos(); // Esto llamará a construirYGuardarValorBoletoStorage
    };

    // --- Para Ticket Único ---
    const handleTicketUnicoChange = (valor) => {
        if (valor.length <= LONGITUD_TICKET && (solonumeros(valor) || valor === "")) {
            setNumeroTicketUnico(valor);
        }
        CamposObligatoriosCorrectos();
    };
    const handleTicketUnicoBlur = () => {
        setErrorTicketUnico(validarFormatoTicket(numeroTicketUnico));
        CamposObligatoriosCorrectos();
    };

    // --- Para Localizador ---
    const handleLocalizadorChange = (valor) => {
        const valorUpper = valor.toUpperCase();
        if (valorUpper.length <= LONGITUD_LOCALIZADOR && (esAlfanumerico(valorUpper) || valorUpper === "")) {
            setLocalizador(valorUpper);
        }
        CamposObligatoriosCorrectos();
    };
    const handleLocalizadorBlur = () => {
        setErrorLocalizador(validarFormatoLocalizador(localizador));
        CamposObligatoriosCorrectos();
    };
    const handleEspecificarChange = (event) => {
        const checked = event.target.checked;
        setEspecificarTicketsLocalizador(checked);
        if (!checked) {
            setTicketsDelLocalizador(['']);
            setErroresTicketsLocalizador([]);
        }
        CamposObligatoriosCorrectos();
    };

    // --- Para Múltiples Tickets del Localizador ---
    const handleTicketLocalizadorChange = (index, valor) => {
        if (valor.length <= LONGITUD_TICKET && (solonumeros(valor) || valor === "")) {
            const nuevos = [...ticketsDelLocalizador];
            nuevos[index] = valor;
            setTicketsDelLocalizador(nuevos);
        }
        CamposObligatoriosCorrectos();
    };
    const handleTicketLocalizadorBlur = (index) => {
        const ticket = ticketsDelLocalizador[index];
        const nuevosErrores = [...erroresTicketsLocalizador];
        nuevosErrores[index] = (ticket && ticket.trim() !== "") ? validarFormatoTicket(ticket) : "";
        setErroresTicketsLocalizador(nuevosErrores);
        CamposObligatoriosCorrectos();
    };
    const addTicketLocalizadorInput = () => {
        setTicketsDelLocalizador([...ticketsDelLocalizador, '']);
        setErroresTicketsLocalizador([...erroresTicketsLocalizador, '']);
    };
    const removeTicketLocalizadorInput = (index) => {
        const nuevosTickets = ticketsDelLocalizador.filter((_, i) => i !== index);
        const nuevosErrores = erroresTicketsLocalizador.filter((_, i) => i !== index);
        setTicketsDelLocalizador(nuevosTickets.length > 0 ? nuevosTickets : ['']);
        setErroresTicketsLocalizador(nuevosErrores);
        CamposObligatoriosCorrectos();
    };

    // -------------------------------------------------------------------------------------------------
    // USEEFFECT Y VALIDACIÓN DEL PASO
    // -------------------------------------------------------------------------------------------------
    function LimpiarTodoParaInicio() {
        window.localStorage.removeItem("TieneDocumentos");
        window.localStorage.removeItem("Boleto"); // Única clave para la info del boleto/loc
        window.localStorage.setItem("Paso1", btoa(false));

        setTieneDocumentos(null);
        setTipoIngreso('localizador'); // Default
        resetearCamposSegunTipo('localizador');
        setFechaCompra(Moment(new Date()));
    }

    useEffect(() => {
        LimpiarTodoParaInicio();

        const tieneDocsGuardado = window.localStorage.getItem("TieneDocumentos");
        if (tieneDocsGuardado === null) {
            setTieneDocumentos(null);
        } else if (tieneDocsGuardado === "true") {
            setTieneDocumentos(true);
        } else {
            setTieneDocumentos(false);
        }

        if (tieneDocsGuardado === "true") {
            const boletoStorage = window.localStorage.getItem("Boleto");
            parsearYEstablecerValorBoletoStorage(boletoStorage);
        } else {
            window.localStorage.setItem("Paso1", btoa(true)); // Si no tiene documentos, paso es válido
        }

    }, []);

    // useEffect para guardar en localStorage cuando cambian los datos relevantes
    useEffect(() => {
        if (tieneDocumentos === true) {// Solo guardar si se indica que tiene documentos
            construirYGuardarValorBoletoStorage();
        }
        // Esta validación se ejecutará cada vez que cambie uno de estos estados,
        // lo cual es bueno para mantener la validez del paso actualizada.
        CamposObligatoriosCorrectos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tieneDocumentos, tipoIngreso, numeroTicketUnico, localizador,
        especificarTicketsLocalizador, ticketsDelLocalizador, fechaCompra
    ]);


    async function CamposObligatoriosCorrectos() {
        if (!tieneDocumentos) {
            window.localStorage.setItem("Paso1", btoa(true));
            return;
        }

        let pasoValidoGlobal = true;

        // Validar Fecha (común a ambos tipos si tieneDocumentos es true)
        if (!fechaCompra || !fechaCompra.isValid() || fechaCompra.isAfter(Moment(), 'day')) {
            pasoValidoGlobal = false;
            // Aquí podrías setear un error específico para la fecha si lo tienes
        }

        if (tipoIngreso === 'ticket') {
            const errTkt = validarFormatoTicket(numeroTicketUnico);
            //setErrorTicketUnico(errTkt); // El blur ya lo hace, pero re-validar es bueno
            if (errTkt !== "") pasoValidoGlobal = false;
        } else if (tipoIngreso === 'localizador') {
            const errLoc = validarFormatoLocalizador(localizador);
            //setErrorLocalizador(errLoc); // El blur ya lo hace
            if (errLoc !== "") pasoValidoGlobal = false;

            if (especificarTicketsLocalizador) {
                const ticketsActivos = ticketsDelLocalizador.filter(t => t.trim() !== "");
                if (ticketsActivos.length === 0) {
                    pasoValidoGlobal = false;
                    // Marcar error si no hay tickets y se deben especificar
                    // (Podrías poner un error general o en el primer campo de ticket)
                    const tempErrores = [...erroresTicketsLocalizador];
                    if (ticketsDelLocalizador.length > 0 && ticketsDelLocalizador[0].trim() === "") {
                        tempErrores[0] = "Al menos un ticket es requerido.";
                        setErroresTicketsLocalizador(tempErrores)
                    }

                } else {
                    let todosSubTicketsValidos = true;
                    const currentSubTicketErrors = ticketsDelLocalizador.map(subTicket => {
                        if (subTicket.trim() === "" && ticketsActivos.length > 0 && ticketsDelLocalizador.length > 1) return "";
                        const err = validarFormatoTicket(subTicket);
                        if (err !== "") todosSubTicketsValidos = false;
                        return err;
                    });
                    // setErroresTicketsLocalizador(currentSubTicketErrors); // El blur ya lo hace
                    if (!todosSubTicketsValidos) pasoValidoGlobal = false;
                }
            }
        }

        window.localStorage.setItem("Paso1", btoa(pasoValidoGlobal));
    }

    return (
        <>
            <LoaderScreen props={ActivarLoader} mensaje={"Validando información"} />
            <div className="_pt-30">
                <div className="theme-page-section-header _ta-l">
                    {/* ... Encabezado ... */}
                    <h5 className="theme-page-section-title">Información de Reembolso</h5>
                    <h5 className="feature-subtitle _op-06">Todos los campos marcados con (*) son obligatorios.</h5>
                    <hr className="style-3"></hr>
                </div>

                <div className="row row-col-gap " data-gutter="20">
                    <div className="col-md-6 ">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> ¿Posee usted documentos para el reembolso?</h5>
                        <div className="theme-payment-page-form-item form-group">
                            <i className="fa fa-angle-down"></i>
                            <select
                                className="form-control seleccionable"
                                value={tieneDocumentos === null ? "null" : tieneDocumentos.toString()}
                                defaultValue={"null"}
                                onChange={(e) => handleTieneDocumentosChange(e.target.value)}
                            >
                                <option value="null">Seleccione</option>
                                <option value="false">No</option>
                                <option value="true">Sí</option>
                            </select>
                        </div>
                    </div>
                </div>
{tieneDocumentos === true && (
                    <Fragment>
                        <div className="row row-col-gap _pt-20" data-gutter="20">
                            <div className="col-md-6">
                                <h5 className=" _c-dark"><span className="_c-p">*</span> Tipo de Documento</h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <i className="fa fa-angle-down"></i>
                                    <select
                                        className="form-control seleccionable"
                                        value={tipoIngreso}
                                        onChange={handleTipoIngresoChange}
                                    >
                                        <option value="localizador">Localizador</option>
                                        <option value="ticket">Ticket</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 ">
                                <h5 className=" _c-dark"><span className="_c-p">*</span> Fecha de compra/reserva</h5>
                                <div className="theme-payment-page-form-item form-group">
                                    {/* ... Popover de Fecha sin cambios ... */}
                                    <Popover
                                        containerClassName={"text-center"}
                                        containerStyle={{ borderRadius: '0px 0px 10px 10px', border: '1.2px solid #CD171A', background: "#f8f8f8", zIndex: "999" }}
                                        arrowStyle={{ background: "#f8f8f8" }}
                                        isOpen={ActivarPopoverFechas}
                                        position={'bottom'}
                                        disableReposition
                                        onClickOutside={() => setActivarPopoverFechas(false)}
                                        content={() => (
                                            <DateRangePicker
                                                minimumDate={new Date(2019, 0, 1)}
                                                maximumDate={new Date()}
                                                selectedLabel={'Fecha de compra o reserva'}
                                                locale={Moment.locale('es')}
                                                showLegend={true}
                                                firstOfWeek={1}
                                                numberOfCalendars={1}
                                                value={fechaCompra}
                                                onSelect={handleFechaChange}
                                                singleDateRange={true}
                                                selectionType={'single'}
                                            />
                                        )}
                                    >
                                        <input
                                            className="form-control seleccionable"
                                            onClick={() => setActivarPopoverFechas(!ActivarPopoverFechas)}
                                            type="text"
                                            value={fechaCompra ? Moment(fechaCompra).format("YYYY/MM/DD") : ""}
                                            placeholder="AAAA/MM/DD"
                                            readOnly
                                        />
                                    </Popover>
                                </div>
                            </div>
                        </div>

                        {tipoIngreso === 'ticket' && (
                            <div className="row row-col-gap _pt-20" data-gutter="20">
                                <div className="col-md-6">
                                    <h5 className=" _c-dark">
                                        <span className="_c-p">*</span> Número de Ticket
                                        {errorTicketUnico && <span className=" _c-p animated fadeIn"> - {errorTicketUnico}</span>}
                                    </h5>
                                    <div className="theme-payment-page-form-item form-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            maxLength={LONGITUD_TICKET}
                                            placeholder={`${PREFIJO_TICKET}...`}
                                            value={numeroTicketUnico}
                                            onChange={(e) => handleTicketUnicoChange(e.target.value)}
                                            onBlur={handleTicketUnicoBlur}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {tipoIngreso === 'localizador' && (
                            <Fragment>
                                <div className="row row-col-gap _pt-20" data-gutter="20">
                                    <div className="col-md-6">
                                        <h5 className=" _c-dark">
                                            <span className="_c-p">*</span> Indique su localizador
                                            {errorLocalizador && <span className=" _c-p animated fadeIn"> - {errorLocalizador}</span>}
                                        </h5>
                                        <div className="theme-payment-page-form-item form-group">
                                            <input
                                                className="form-control"
                                                type="text"
                                                maxLength={LONGITUD_LOCALIZADOR}
                                                placeholder="Ej: ABCD12"
                                                value={localizador}
                                                onChange={(e) => handleLocalizadorChange(e.target.value)}
                                                onBlur={handleLocalizadorBlur}
                                                style={{ textTransform: 'uppercase' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row row-col-gap _pt-20" data-gutter="20">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="checkbox">
                                                <label style={{ fontSize: '0.9em' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={especificarTicketsLocalizador}
                                                        onChange={handleEspecificarChange}
                                                    />
                                                    <span className="_ml-5">¿Desea reembolsar uno o múltiples tickets?</span>
                                                </label>
                                            </div>
                                            <small className="d-block _op-07 _mt-0">
                                                Si no marca esta opción, se entenderá que el reembolso aplica a todos los tickets asociados al localizador ingresado (si corresponde según las políticas).
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                {especificarTicketsLocalizador && (
                                    <div className="_pt-10">
                                        <h5 className=" _c-dark"><span className="_c-p">*</span> Indique el número de ticket
                                            {ticketsDelLocalizador.length === 1 && ticketsDelLocalizador[0].trim() === "" && erroresTicketsLocalizador[0] &&
                                                <span className=" _c-p animated fadeIn"> - {erroresTicketsLocalizador[0]}</span>
                                            }
                                        </h5>
                                        {ticketsDelLocalizador.map((ticket, index) => (
                                            <div key={index} className="row row-col-gap _pb-10 align-items-center" data-gutter="10">
                                                <div className="col-md-5">
                                                    {/* ... Input de ticket individual ... */}
                                                    <div className="theme-payment-page-form-item form-group">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            maxLength={LONGITUD_TICKET}
                                                            placeholder={`Ticket ${index + 1} (Ej: ${PREFIJO_TICKET}...)`}
                                                            value={ticket}
                                                            onChange={(e) => handleTicketLocalizadorChange(index, e.target.value)}
                                                            onBlur={() => handleTicketLocalizadorBlur(index)}
                                                        />
                                                    </div>
                                                    {erroresTicketsLocalizador[index] && ticket.trim() !== "" && <small className="_c-p animated fadeIn d-block">{erroresTicketsLocalizador[index]}</small>}
                                                </div>
                                                <div className="col-md-1">
                                                    {/* ... Botón de remover ... */}
                                                    {ticketsDelLocalizador.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-link _c-p _p-0"
                                                            onClick={() => removeTicketLocalizadorInput(index)}
                                                            aria-label="Remover ticket"
                                                        >
                                                            <i className="fa fa-minus-circle"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="row">
                                            <div className="col-md-6 _pt-5">
                                                {/* ... Botón de añadir ... */}
                                                <button type="button" className="btn btn-sm theme-btn-secundario" onClick={addTicketLocalizadorInput}>
                                                    <i className="fa fa-plus-circle _mr-5"></i> Añadir otro ticket
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Fragment>
                        )}

                    </Fragment>
                )}
            </div>
        </>
    );
}

export default Paso1;